var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPaperPlane = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3618 16.913L13.3835 19.5948C13.5711 19.7615 13.8035 19.8829 14.0587 19.9473C14.3139 20.0118 14.5834 20.0172 14.8416 19.963C15.0998 19.9089 15.3381 19.797 15.534 19.638C15.7299 19.479 15.8767 19.2782 15.9607 19.0545L20.9198 5.82015C21.0114 5.57654 21.0248 5.31507 20.9585 5.06507C20.8922 4.81507 20.7489 4.58644 20.5445 4.40482C20.3401 4.2232 20.0829 4.09578 19.8016 4.03686C19.5203 3.97794 19.2261 3.98984 18.952 4.07124L4.06076 8.48228C3.8099 8.5572 3.58469 8.68771 3.40638 8.8615C3.22807 9.03529 3.10256 9.24661 3.04171 9.4755C2.98086 9.70439 2.98667 9.94329 3.05861 10.1696C3.13054 10.396 3.26621 10.6023 3.45281 10.769L7.24867 14.1462L7.11988 18.4108L10.3618 16.913Z",
    stroke: "#767380",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4752 4.3468L7.24854 14.1461",
    stroke: "#767380",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPaperPlane, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/paper-plane.a8bfa1b6.svg";
export { ForwardRef as ReactComponent };